import { ClearBaseIcon } from '@tableau/icons/ClearBaseIcon';
import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { WelcomeChannelTestIds } from '../../../home/components/WelcomeChannel';
import { WelcomeChannelStyles } from '../../../home/styles/WelcomeChannelStyles';

export interface WelcomeChannelCloseButtonProps {
  handleClick: () => void;
  tooltipText: string;
  disabled: boolean;
  footerOnly?: boolean; // If only the server footer is shown and not the default banner
}

export class WelcomeChannelCloseButton extends React.PureComponent<WelcomeChannelCloseButtonProps> {

  render() {
    return (
      <div className={this.props.footerOnly ? WelcomeChannelStyles.closeButtonFooterContainer : WelcomeChannelStyles.closeButtonContainer}>
        <Tooltip
          afterDelay
          position={TooltipPosition.Right}
          testId={WelcomeChannelTestIds.closeButtonTooltip}
          tooltipContent={this.props.tooltipText}
        >
          <ButtonWidget
            buttonType={ButtonType.LowEmphasis}
            onClick={this.props.handleClick}
            testId={WelcomeChannelTestIds.closeButton}
            className={WelcomeChannelStyles.CloseButtonStyleName}
            disabled={this.props.disabled}
          >
            <ClearBaseIcon size={14} alt={Messages.home_welcomeChannel_dismiss_alttext()} />
          </ButtonWidget>
        </Tooltip>
      </div>
    );
  }
}
